import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 6,
	height: 10,
	viewBox: "0 0 6 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.361871 7.27637L2.55318 2.8944C2.73747 2.52589 3.26337 2.52592 3.44761 2.89445L5.63826 7.27642C5.80446 7.60887 5.56272 8 5.19104 8H0.809072C0.437367 8 0.19562 7.60882 0.361871 7.27637Z",
		fill: "#525252"
	})
});
export default SvgArrowUp;
